import moment from 'moment';
import { toVertexLogoURL } from '~/utils/transform.js';


const formatTime = date => date && moment(date).format('L');


export const featureFlagToAPI = ({ name, ...rest }) => ({
    name: name.trim().replace(/\s/gi, '_').toLowerCase(),
    ...rest,
});

// TODO: create API ticket: return empty list when no flags configued
export const featureFlagToStore = feature_flags => (feature_flags === null ? [] : feature_flags);

// =============================================================================
// Search
// =============================================================================
// normalizing / fixing data
export const searchResultsToStore = (results, filters = {}) => {
    filters = new Map(Object.entries(filters));

    return results.map(({
        portal,
        created,
        modified,
        logo_id,
        logo_url,
        ...item
    }) => {
        // seems like some organizations are comming back without the portal prop
        if (filters.has('portals')) {
            item.portal = typeof portal !== 'boolean' ? false : portal;
        }

        item.created = formatTime(created);
        item.modified = formatTime(modified);
        item.logo = toVertexLogoURL({ logo_id, logo_url });

        return item;
    });
};

